import { HttpResult, Option } from "widgets-for-react"
import { EventDetails } from "../../backendApi/generated"
import { JumboComponent, JumboProps } from "../Jumbo/Jumbo"
import { EventBlocks, EventDetailsState, initialEventDetailsState } from "./EventDetails/EventDetailsState"
import { EventOverviewState, initialEventOverviewState } from "./EventOverview/EventOverviewState"
import { moment } from '../../utils/moment'

declare global {
  interface Window {
    eventsPrefix: string
  }
}

export type DetailsFilter = (e: EventDetails, i: number) => boolean

export interface EventsConfig {
  prefix: string
  loadJumbo: () => Promise<HttpResult<JumboProps>>
  Jumbo: JumboComponent
  renderCustomCmsPage: (cmsContent: any) => Option<JSX.Element>
  Blocks: (props: { blocks: EventBlocks }) => JSX.Element
  overviewPage: {
    locationFilter: {
      kind: 'none'
    } |
    {
      kind: 'location' | 'region'
      heading: string
      defaultLabel: string
    }
  }
  detailPage: {
    filterChildren: DetailsFilter
    filterGroupedChildren: DetailsFilter
    eventGroupingTarget: number
  }
}

export const defaultEventsConfig: Pick<EventsConfig, 'prefix' | 'overviewPage' | 'detailPage'> = {
  prefix: window.eventsPrefix || '/agenda',
  overviewPage: {
    locationFilter: {
      kind: 'region',
      heading: 'Waar?',
      defaultLabel: 'Alle locaties'
    }
  },
  detailPage: {
    filterChildren: (e: EventDetails, i: number) => i < 40 || moment(e.Start).isBefore(moment().add(30, 'days')),
    filterGroupedChildren: (e: EventDetails, i: number) => i < 10,
    eventGroupingTarget: 8
  }
}

export interface EventsApplicationState {
  eventDetails: EventDetailsState
  eventOverview: EventOverviewState
}

export const initialEventsApplicationState: EventsApplicationState = {
  eventDetails: initialEventDetailsState,
  eventOverview: initialEventOverviewState
}